import { ILabel, ILabelParameter, ILanguageRules } from "./Interfaces";

export class LabelsHelper
{
    public rules: ILanguageRules;
    public labels: Map<string, ILabel>;

    constructor(labels: Map<string, ILabel>, rules: ILanguageRules)
    {
        this.labels = labels;
        this.rules = rules;
    }

    public value(key: string, ...parameters: ILabelParameter[]): string
    {
        const label = this.labels.get(key) ??
        {
            key: key,
            value: `[${key}]`,
            zero: '',
            one: '',
            two: '',
            few: '',
            many: '',
            other: '',
        };

        let value: string;
        if (label.value)
        {
            value = label.value;
        }
        else
        {
            const countAsAny = parameters.find(i => i.name == 'count')?.value;
            const countAsNumberOrString = (typeof countAsAny == 'number' || typeof countAsAny == 'string') ? countAsAny : 0;
            value = this.rules.getPlural(label, countAsNumberOrString);
        }

        parameters.map(i => value = value.replace(new RegExp(`{${i.name}}`, 'gi'), i.value));
        return value;
    }
}
